import React from 'react';
import { Image, StyleSheet } from 'react-native';

import { Box } from '@components/Restyle';

import { confettiGif } from '../../../assets/Tutorials/Project';

type ConfettiProps = {
  visible: boolean;
};

export const Confetti = ({ visible }: ConfettiProps) => {
  if (!visible) return null;

  return (
    <Box style={styles.container} pointerEvents='none' zIndex={9999}>
      <Image source={confettiGif} style={styles.image} resizeMode='cover' />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  image: {
    width: '100%',
    height: '100%',
  },
});
